<template>
  <div class="research">
   <Header/>
    <h1>Onderzoek</h1>
    <div class="row">
    <div v-for="research_m in research" class="col-md-12 research_item">
      <div class="row">
        <div class="col-md-4">
        <img src="https://today.uconn.edu/wp-content/uploads/2012/11/research_lab_shutterstock_88062886.jpg"/>
      </div>
      <div class="col-md-8 content">
        <h5>{{ research_m.title.rendered }}</h5>
        <p v-html="research_m.excerpt.rendered"></p>
      </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Header from "./Header.vue";

export default {
  name: 'Research',
  components: { Header },
  data () {
    return {
      research: []
    }
  },
  created: function(){
    this.$http.get('wp/v2/research').then(response => {
      for(let research_member in response.data){
        this.research.push(response.data[research_member]);
      }
    }, error => {
      alert(error);
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/more_info/research.vue